<template>
  <header :class="wrapperNs.b()" :style="style" data-test-name="header">
    <div
      :class="[
        ns.b(),
        ns.is('shadow', shadow),
        ns.is('border', border),
        ns.is('fixed', fixed),
        $attrs.class,
      ]"
    >
      <slot />
    </div>
  </header>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { isNumber } from 'lodash-unified'
import { useNamespace } from '@bigin/hooks'

import type { CSSProperties } from 'vue'

defineOptions({
  name: 'BHeader',
})

const props = defineProps({
  height: {
    type: [String, Number],
    default: null,
  },
  shadow: Boolean,
  border: Boolean,
  fixed: Boolean,
})

const ns = useNamespace('header')
const wrapperNs = useNamespace('header-wrapper')
const style = computed(() => {
  return props.height
    ? (ns.cssVarBlock({
        height: isNumber(props.height) ? `${props.height}px` : props.height,
      }) as CSSProperties)
    : {}
})
</script>
